<template>
<div>
</div>
</template>

<script>
import firebase from "firebase/compat/app";
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/analytics';

export default {
  data() {
    return {
      user: ''
    };
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
      } else {
        this.$router.push('/login')
      }
    });
  },
};

</script>
